import { ZoomImageContainer } from "shared/components/Parameters";
import Layout from "../../components/mainPage/Layout";
import SNMPClient from "../../images/systemComponents/SNMPClient.svg";
export const Page = () => {
    return <Layout >
        <div className="container">
            <div className="article-container">
                <h1 className="mb-4 ">
                    SNMP клиент
                </h1>
                <div className=" w-100 align-start  ">
                    <p >
                        Использование <b>SNMP (Simple Network Management Protocol) клиента</b> в SCADA NPT Expert позволяет решать ряд задач, связанных с мониторингом, управлением и интеграцией сетевых устройств и оборудования. SNMP — это стандартный протокол для управления сетевыми устройствами, который широко применяется в SCADA-системах для сбора данных и контроля состояния оборудования.
                    </p>
                    <div style={{ float: 'right' }}>
                        <div style={{ maxWidth: '500px' }}>
                            <ZoomImageContainer
                                image={SNMPClient}
                            />
                            {/* <img
                                src={SNMPClient}
                                className="mb-4 w-100 "
                                alt="SMTP Клиент"
                            /> */}
                        </div>
                    </div>
                    <div>
                        <p>Основные задачи, которые решает использование SNMP клиента в SCADA NPT Expert, включают:</p>

                        <ul className="mb-4 description__list">

                            <li className="mb-1 description__number-li"><b>Мониторинг состояния сетевых устройств</b>
                                <ul>
                                    <li>SNMP клиент позволяет SCADA NPT Expert собирать данные о состоянии сетевых устройств, таких как маршрутизаторы, коммутаторы, серверы, источники бесперебойного питания (ИБП) и другие устройства, поддерживающие SNMP. Такие данные включают информацию о загрузке процессора, использовании памяти, состоянии интерфейсов и других параметрах.
                                    </li>
                                </ul>
                            </li>
                            <li className="mb-1 description__number-li"><b>Сбор данных с оборудования</b>
                                <ul>
                                    <li>SNMP клиент используется для опроса устройств и сбора данных, таких как:
                                        <ul>
                                            <li>Температура, напряжение, мощность (для ИБП).</li>
                                            <li>Состояние сетевых интерфейсов (активность, ошибки, скорость передачи данных).</li>
                                            <li>Параметры работы серверов и других IT-устройств.</li>
                                        </ul>
                                    </li>
                                </ul>
                            </li>
                            <li className="mb-1 description__number-li"><b>Интеграция с MIB (Management Information Base)</b>
                                <ul>
                                    <li>SNMP клиент взаимодействует с MIB — базой управляющей информации, которая содержит объекты (MIB-переменные), доступные для чтения и записи. Это позволяет SCADA NPT Expert получать структурированные данные от устройств и управлять ими .
                                    </li>
                                </ul>
                            </li>
                            <li className="mb-1 description__number-li"><b>Оповещение о событиях и авариях</b>
                                <ul>
                                    <li>SNMP поддерживает механизм ловушек (traps), которые позволяют устройствам отправлять асинхронные уведомления о критических событиях, таких как:
                                        <ul>
                                            <li>Перегрев оборудования.</li>
                                            <li>Потеря связи.</li>
                                            <li>Превышение пороговых значений параметров.</li>

                                        </ul>
                                    </li>
                                    <li>Это позволяет SCADA NPT Expert оперативно реагировать на аварийные ситуации .</li>
                                </ul>
                            </li>
                            <li className="mb-1 description__number-li"><b>Управление устройствами</b>
                                <ul>
                                    <li>SNMP клиент может не только собирать данные, но и отправлять команды на устройства для изменения их параметров. Например:
                                        <ul>
                                            <li>Перезагрузка устройства.</li>
                                            <li>Изменение конфигурации сетевых интерфейсов.</li>
                                            <li>Управление питанием (для ИБП).</li>
                                        </ul>
                                    </li>
                                </ul>
                            </li>
                            <li className="mb-1 description__number-li"><b>Поддержка различных версий SNMP</b>
                                <ul>
                                    <li>SNMP клиент в SCADA NPT Expert поддерживает все основные версии протокола (v1, v2c, v3), что обеспечивает совместимость с широким спектром устройств. В SNMP v3 добавлены функции шифрования и аутентификации, что повышает безопасность передачи данных.
                                    </li>
                                </ul>
                            </li>


                        </ul>
                    </div>
                    <div style={{ clear: 'both' }}></div>

                </div>

            </div>
        </div>
    </Layout>
}

export const meta = {
    title: 'SNMP клиент',
    description: 'Использование SNMP (Simple Network Management Protocol) клиента в SCADA NPT Expert позволяет решать ряд задач, связанных с мониторингом, управлением и интеграцией сетевых устройств и оборудования. SNMP — это стандартный протокол для управления сетевыми устройствами, который широко применяется в SCADA-системах для сбора данных и контроля состояния оборудования.'
}